import React from 'react';
import { useNavigate } from 'react-router-dom';

const Goal12 = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate('/#sdg-goals');
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <button
        onClick={handleGoBack}
        className="mb-6 flex items-center text-gray-600 hover:text-gray-900 transition-colors duration-200"
      >
        <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
        </svg>
        Go Back
      </button>
      <h2 className="text-3xl font-bold mb-4">SDG 12 Responsible Consumption and Production</h2>
      <p className="mb-4">
        Ensure sustainable consumption and production patterns.
      </p>
      <a
        href="https://sdg-tracker.org/sustainable-consumption-production "
        target="_blank"
        rel="noopener noreferrer"
        className="text-blue-600 hover:underline mb-6 inline-block"
      >
        https://sdg-tracker.org/sustainable-consumption-production
      </a>

      <div className="overflow-x-auto">
        <table className="min-w-full bg-white border border-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">No.</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Targets</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Target Details</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            <tr>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">12.1</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Implement the 10-year sustainable consumption and production framework</td>
              <td className="px-6 py-4 text-sm text-gray-900">
                Implement the 10‑Year Framework of Programmes on Sustainable Consumption and Production Patterns, all countries taking action, with developed countries taking the lead, taking into account the development and capabilities of developing countries.
              </td>
            </tr>
            <tr>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">12.2</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Sustainable management and use of natural resources</td>
              <td className="px-6 py-4 text-sm text-gray-900">
                By 2030, achieve the sustainable management and efficient use of natural resources.
              </td>
            </tr>
            <tr>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">12.3</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Halve global per capita food waste</td>
              <td className="px-6 py-4 text-sm text-gray-900">
                By 2030, halve per capita global food waste at the retail and consumer levels and reduce food losses along production and supply chains, including post-harvest losses.
              </td>
            </tr>
            <tr>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">12.4</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Responsible management of chemicals and waste</td>
              <td className="px-6 py-4 text-sm text-gray-900">
                By 2020, achieve the environmentally sound management of chemicals and all wastes throughout their life cycle, in accordance with agreed international frameworks, and significantly reduce their release to air, water and soil in order to minimize their adverse impacts on human health and the environment.
              </td>
            </tr>
            <tr>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">12.5</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Substantially reduce waste generation</td>
              <td className="px-6 py-4 text-sm text-gray-900">
                By 2030, substantially reduce waste generation through prevention, reduction, recycling and reuse.
              </td>
            </tr>
            <tr>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">12.6</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Encourage companies to adopt sustainable practices and sustainability reporting</td>
              <td className="px-6 py-4 text-sm text-gray-900">
                Encourage companies, especially large and transnational companies, to adopt sustainable practices and to integrate sustainability information into their reporting cycle.
              </td>
            </tr>
            <tr>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">12.7</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Promote sustainable public procurement practices</td>
              <td className="px-6 py-4 text-sm text-gray-900">
                Promote public procurement practices that are sustainable, in accordance with national policies and priorities.
              </td>
            </tr>
            <tr>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">12.8</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Promote universal understanding of sustainable lifestyles</td>
              <td className="px-6 py-4 text-sm text-gray-900">
                By 2030, ensure that people everywhere have the relevant information and awareness for sustainable development and lifestyles in harmony with nature.
              </td>
            </tr>
            <tr>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">12.A</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Support developing countries' scientific and technological capacity for sustainable consumption and production</td>
              <td className="px-6 py-4 text-sm text-gray-900">
                Support developing countries to strengthen their scientific and technological capacity to move towards more sustainable patterns of consumption and production.
              </td>
            </tr>
            <tr>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">12.B</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Develop and implement tools to monitor sustainable tourism</td>
              <td className="px-6 py-4 text-sm text-gray-900">
                Develop and implement tools to monitor sustainable development impacts for sustainable tourism that creates jobs and promotes local culture and products.
              </td>
            </tr>
            <tr>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">12.C</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Remove market distortions that encourage wasteful consumption</td>
              <td className="px-6 py-4 text-sm text-gray-900">
                Rationalize inefficient fossil-fuel subsidies that encourage wasteful consumption by removing market distortions, in accordance with national circumstances, including by restructuring taxation and phasing out those harmful subsidies, where they exist, to reflect their environmental impacts, taking fully into account the specific needs and conditions of developing countries and minimizing the possible adverse impacts on their development in a manner that protects the poor and the affected communities.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Goal12;
